<template>
  <a-card :bordered="false">
    <a-form :form="form">
      <a-row v-if="visible">
        <a-col :span="9" style="padding-left: 20px">
          <a-form-item
            label="页面模板："
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-select
              v-decorator="[
                'tmplId',
                { rules: [{ required: true, message: '请选择页面模板' }] }
              ]"
              placeholder="请选择页面模板"
              disabled
            >
              <a-select-option
                v-for="(item, index) in pageTmplList"
                :key="index"
                :value="item.id"
                >{{ item.name }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <img :src="tmpl_thumbnail" alt="" />
        </a-col>
        <a-col :span="15">
          <a-form-item
            label="标题"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <a-input
              v-decorator="[
                'title',
                { rules: [{ required: true, message: '请选择页面模板' }] }
              ]"
              :maxLength="15"
            />
          </a-form-item>
          <a-form-item
            :label="tmpl_type == '0' ? '头图：' : '基金展示图：'"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <j-image-upload
              text="上传"
              v-decorator="[
                'abovePic',
                {
                  rules: [
                    {
                      required: true,
                      message:
                        '请上传' + (tmpl_type == '0' ? '头图' : '基金展示图')
                    }
                  ]
                }
              ]"
            ></j-image-upload>
          </a-form-item>

          <a-form-model ref="form1" :model="form1">
            <a-form-item
              v-if="tmpl_type == '0'"
              label="基金卡片配置："
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <div class="cardIndex">
                <input
                  type="button"
                  v-for="(item, index) in form1.pubPagePrdSetDtos"
                  :value="index + 1"
                  :key="index"
                  @click="showCardIndex = index"
                  :class="
                    showCardIndex === index ? 'item ant-btn-primary' : 'item'
                  "
                />
                <a-button
                  style="margin-left: 10px"
                  @click="addCardIndex()"
                  size="small"
                  icon="plus"
                ></a-button>
              </div>
            </a-form-item>
            <div
              class="fundCard"
              :style="
                tmpl_type == '0'
                  ? 'border:1px solid #b3b3b3; margin:0 0 20px 50px; padding: 10px 20px;'
                  : ''
              "
            >
              <div
                v-show="index === showCardIndex"
                v-for="(domain, index) in form1.pubPagePrdSetDtos"
                :key="index"
              >
                <div v-if="tmpl_type == '0'">
                  <div style="text-align: right">
                    <a-button
                      style="z-index: 99999"
                      type="link"
                      size="small"
                      @click="delCurrent(index)"
                      >删除</a-button
                    >
                  </div>
                  <a-form-model-item
                    label="选择卡片模板："
                    :prop="'pubPagePrdSetDtos.' + index + '.tmplId'"
                    :rules="{
                      required: true,
                      message: '卡片模板不能为空',
                      trigger: 'blur'
                    }"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-select v-model="domain.tmplId" placeholder="请选择">
                      <a-select-option
                        v-for="(item, index) in fundTmplList"
                        :key="index"
                        :value="item.id"
                        >{{ item.name }}</a-select-option
                      >
                    </a-select>
                  </a-form-model-item>
                  <a-form-model-item
                    label="选择产品："
                    :prop="'pubPagePrdSetDtos.' + index + '.fundCode'"
                    :rules="{
                      required: true,
                      message: '产品不能为空',
                      trigger: 'blur'
                    }"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-select
                      showSearch
                      v-model="domain.fundCode"
                      placeholder="请选择"
                      :filter-option="filterOption"
                      @change="fundHandleChange(domain.fundCode, index)"
                    >
                      <a-select-option
                        v-for="(item, index) in fundOptions"
                        :key="index"
                        :value="item.fundCode"
                      >
                        {{ item.fundCode }} / {{ item.fundName }}
                      </a-select-option>
                    </a-select>
                  </a-form-model-item>
                  <a-form-model-item
                    label="位置："
                    :prop="'pubPagePrdSetDtos.' + index + '.showIndex'"
                    :rules="{
                      required: true,
                      message: '位置不能为空',
                      trigger: 'blur'
                    }"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-input v-model="domain.showIndex" placeholder="请输入" />
                  </a-form-model-item>
                  <a-form-model-item
                    label="选择展示项："
                    :prop="'pubPagePrdSetDtos.' + index + '.dispPointer'"
                    :rules="{
                      required: true,
                      message: '展示业绩不能为空',
                      trigger: 'blur'
                    }"
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                  >
                    <a-checkbox-group
                      v-model="domain.dispPointer"
                      @change="dispPointerChange(index)"
                    >
                      <a-row>
                        <a-col
                          :span="8"
                          v-for="(item, index) in timeList"
                          :key="index"
                        >
                          <a-checkbox :value="item.key">
                            {{ item.name }}
                          </a-checkbox>
                        </a-col>
                        <span style="color: red"
                          >（提示：最多选择三个选项）</span
                        >
                      </a-row>
                    </a-checkbox-group>
                  </a-form-model-item>
                </div>

                <a-form-model-item
                  label="按钮文字："
                  :prop="'pubPagePrdSetDtos.' + index + '.btnText'"
                  :rules="{
                    required: true,
                    message: '按钮文字不能为空',
                    trigger: 'blur'
                  }"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                >
                  <a-input v-model="domain.btnText" placeholder="请输入" />
                </a-form-model-item>
                <a-form-model-item
                  label="宣传理由："
                  :prop="'pubPagePrdSetDtos.' + index + '.pubText'"
                  :rules="{
                    required: true,
                    message: '宣传理由不能为空',
                    trigger: 'blur'
                  }"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                >
                  <a-input v-model="domain.pubText" placeholder="请输入" />
                </a-form-model-item>
                <a-form-model-item
                  v-if="tmpl_type == '1'"
                  label="按钮跳转链接："
                  :prop="'pubPagePrdSetDtos.' + index + '.linkUrl'"
                  :rules="{
                    required: true,
                    message: '按钮跳转链接不能为空',
                    trigger: 'blur'
                  }"
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                >
                  <a-input v-model="domain.linkUrl" placeholder="请输入" />
                </a-form-model-item>
              </div>
            </div>
          </a-form-model>
          <a-form-item
            v-if="tmpl_type == '0'"
            label="基金展示图："
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <j-image-upload
              text="上传"
              v-decorator="[
                'belowPic',
                { rules: [{ required: true, message: '请上传基金展示图' }] }
              ]"
            ></j-image-upload>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <div class="btns">
      <a-button class="cancelBtn" @click="pageHandleCancel">取消</a-button>
      <a-button type="primary" @click="pageHandleOk" class="mid"
        >生成产品宣传页</a-button
      >
    </div>
    <a-modal
      v-model="successVisible"
      style="width: 600px"
      title="生成产品宣传页"
      footer=""
    >
      <div>
        <h2 style="text-align: center">宣传页生成成功！</h2>
        <div>
          链接：<span>{{ linkUrl }}</span>
          <a-button
            class="tag-read"
            style="margin-left: 15px"
            :data-clipboard-text="linkUrl"
            @click="onCopy"
            size="small"
            type="button"
            >复制链接</a-button
          >
        </div>
      </div>
      <div style="margin: 40px 0 0 200px">
        <a-button
          type="dashed"
          @click="pageHandleCancel"
          style="margin-left: 8px"
          >关闭</a-button
        >
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import JCheckbox from '@/components/jeecg/JCheckbox';
import JImageUpload from '@/components/jeecg/JImageUpload';
import { getAction } from '@/api/manage';
import Clipboard from 'clipboard';
import pick from 'lodash.pick';

export default {
  name: 'PubPageAdd',
  components: {
    JCheckbox,
    JImageUpload
  },
  data() {
    return {
      form: this.$form.createForm(this),
      form1: {
        pubPagePrdSetDtos: []
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      timeList: [
        {
          key: 'd',
          name: '日涨幅'
        },
        {
          key: 'w',
          name: '近一周'
        },
        {
          key: 'm',
          name: '近一月'
        },
        {
          key: '3m',
          name: '近三月'
        },
        {
          key: '6m',
          name: '近半年'
        },
        {
          key: 'y',
          name: '今年以来'
        },
        {
          key: '1y',
          name: '近一年'
        },
        {
          key: '2y',
          name: '近两年'
        },
        {
          key: '3y',
          name: '近三年'
        },
        {
          key: 'a',
          name: '成立以来'
        },
        {
          key: 'endTime',
          name: '募集结束时间'
        }
      ],
      tmpl_type: '0',
      tmpl_thumbnail: '',
      url: {
        pageDetail: process.env.VUE_APP_CMS_CONTENT + '/cont/pubpage/queryById',
        tmplList: process.env.VUE_APP_CMS_CONTENT + '/cont/pubpagetmpl/list',
        pageSetList:
          process.env.VUE_APP_CMS_CONTENT + '/cont/pageset/pageSetList',
        fundList:
          process.env.VUE_APP_CMS_PRODUCT + '//product/fundInfo/listAll',
        edit: process.env.VUE_APP_CMS_CONTENT + '/cont/pubpage/edit'
      },
      fundOptions: [],
      pageTmplList: [],
      fundTmplList: [],
      successVisible: false,
      linkUrl: '',
      pageId: '',
      showCardIndex: 0,
      model: {},
      visible: false
    };
  },
  created() {
    this.pageId = this.$route.query.id;
    this.initData({});
  },
  methods: {
    initData(record) {
      this.form.resetFields();
      getAction(this.url.pageDetail, { id: this.pageId })
        .then(res => {
          if (res.success) {
            let { result } = res;
            record = result;
          } else {
            this.$message.error(res.message);
          }
        })
        .then(() => {
          getAction(this.url.pageSetList, { pageId: this.pageId }).then(res => {
            if (res.success) {
              let { result } = res;
              this.form1.pubPagePrdSetDtos = result;
              this.visible = true;
              this.$nextTick(() => {
                this.model = Object.assign({}, record);
                console.log('==================', this.model);
                this.form.setFieldsValue(
                  pick(this.model, 'tmplId', 'title', 'abovePic', 'belowPic')
                );
              });
              this.getTmplList();
            } else {
              this.$message.error(res.message);
            }
          });
        });
      this.getFundList();
    },
    getTmplList() {
      getAction(this.url.tmplList, {}).then(res => {
        if (res.success) {
          let data = res.result;
          data.map((item, i) => {
            if (item.category == '0') {
              this.fundTmplList.push(item);
            } else if (item.category == '1') {
              this.pageTmplList.push(item);
              if (item.id === this.form.getFieldValue('tmplId')) {
                this.tmpl_thumbnail = item.thumbnail;
                this.tmpl_type = item.type;
              }
            }
          });
        }
      });
    },
    getFundList() {
      getAction(this.url.fundList, {}).then(res => {
        if (res.success) {
          this.fundOptions = res.result;
        }
      });
    },
    pageHandleOk() {
      var that = this;
      this.form.validateFields((err, values) => {
        if (!err) {
          values.tempType = this.tmpl_type;
          values.id = this.pageId;
          values.pubPagePrdSetDtos = this.form1.pubPagePrdSetDtos;
          if (this.tmpl_type == '0') {
            this.$refs.form1.validate(valid => {
              if (valid) {
                this.submit(values);
              } else {
                return false;
              }
            });
          } else {
            this.submit(values);
          }
        }
      });
    },
    submit(params) {
      this.$http
        .post(this.url.edit, params, {
          headers: { 'Content-Type': 'application/json; charset=utf-8' }
        })
        .then(res => {
          if (res.success) {
            console.log(res.result);
            this.successVisible = true;
            this.linkUrl = res.result;
          } else {
            this.$message.warning(res.message);
          }
        });
    },
    pageHandleCancel() {
      this.$router.push('/contentManage/pubPage/pageList/PubPageList');
    },
    /** 添加基金卡片索引*/
    addCardIndex() {
      this.form1.pubPagePrdSetDtos.push({});
    },
    /** 删除当前基金配置*/
    delCurrent(showIndex) {
      var that = this;
      if (this.form1.pubPagePrdSetDtos.length === 1) {
        // 不能再删除了
        this.$message.warning('不能再删除了');
      } else {
        this.form1.pubPagePrdSetDtos = this.form1.pubPagePrdSetDtos.filter(
          (item, index) => {
            return index != showIndex;
          }
        );
        if (this.showCardIndex > 0) {
          this.showCardIndex--;
        }
      }
    },
    fundHandleChange(val, index) {
      let obj = this.fundOptions.find(function(item) {
        return item.fundCode === val;
      });
      this.form1.pubPagePrdSetDtos[index].fundName = obj.fundName;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    onCopy() {
      var clipboard = new Clipboard('.tag-read');
      clipboard.on('success', e => {
        console.log('复制成功');
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on('error', e => {
        // 不支持复制
        console.log('该浏览器不支持自动复制');
        // 释放内存
        clipboard.destroy();
      });
    },
    dispPointerChange(index) {
      let dispPointer = this.form1.pubPagePrdSetDtos[index].dispPointer;
      // 最多三条
      if (dispPointer.length > 3) {
        dispPointer.splice(0, 1);
      }
      let newDis = [];
      // 将dispPointer 从前到后排序
      this.timeList.forEach((item, index) => {
        dispPointer.forEach((item1, index1) => {
          if (item.key === item1) {
            newDis.push(item.key);
          }
        });
      });
      this.form1.pubPagePrdSetDtos[index].dispPointer = newDis;
    }
  }
};
</script>

<style scoped lang="less">
.ant-select-selection {
  height: 20px;
}

.ant-form-item {
  margin-bottom: 10px;
}

.item {
  margin-left: 10px;
  line-height: normal;
}

#delIcon {
  display: block;
  float: left;
  width: 100%;
  margin-left: 400px;
  clear: both;
}
.btns {
  margin-top: 30px;
  text-align: center;
  .mid {
    margin: 0 40px;
  }
  .ant-btn {
    width: 120px;
    height: 30px;
  }
  .cancelBtn {
    width: 60px;
  }
}
</style>
